import {
  assignInWith,
  isEmpty as _isEmpty,
  isNumber,
  partialRight,
} from "lodash";

const customizer = (objValue, srcValue) => {
  return !srcValue ? objValue : srcValue;
}

// object exnted 값이 있는 것 우선
export const assignInByExistence = partialRight(assignInWith, customizer);

export const isEmpty = (value) => {
  return _isEmpty(value) && !isNumber(value)
}


// 깊이 탐색
export const dps = (list, value, subName, targetKey = 'idx',) => {
  if (!subName) {
    alert('subName is required');
    return
  }
  for (const item of list) {
    // 현재 item의 value가 찾고자 하는 value와 일치하는 경우, 해당 item를 반환합니다.
    if (item[targetKey] === value) {
      return item;
    }
    // 현재 item에 subName가 존재하는 경우, 재귀적으로 탐색을 수행합니다.
    if (item[subName] && item[subName].length > 0) {
      const found = dps(item[subName], value, subName, targetKey);
      if (found) {
        return found; // 찾은 경우, 해당 객체를 반환합니다.
      }
    }
  }
  // 전체 배열에서 원하는 value를 가진 객체를 찾지 못한 경우, null을 반환합니다.
  return null;

}